<template>
  <v-list-item-content :class="compact ? 'pa-0' : 'pb-0'">
    <v-text-field v-model="editValue" :rules="rule" :label="compact ? null : (noempty ? label + '*' : label)"
      @keydown.enter.exact="clickedit ? endInternalEdit(true) : null"
      @keydown.tab.exact="clickedit ? endInternalEdit(true) : null"
      @keydown.esc.exact="clickedit ? endInternalEdit() : null" @focusout="clickedit ? endInternalEdit() : null"
      :hide-details="compact ? true : 'auto'" :class="compact ? 'smallerinputtext' : ''" :counter="charlimit"
      :outlined="compact ? false : true" :suffix="suffix" autofocus dense>
    </v-text-field>
  </v-list-item-content>
</template>


<script>
import rules from "@/helpers/Mixins/RuleMixin.js";

export default {
  name: "EditModeTemplate",
  props: [
    "label",
    "keyname",
    "value",
    "edit",
    "internalEdit",
    "noempty",
    "charlimit",
    "email",
    "tlf",
    "onlyedit",
    "compact",
    "suffix",
    "clickedit",
    "loading",
  ],
  mixins: [rules],

  data: () => ({ editValue: null, emitStack: [] }),

  mounted() {
    this.editValue = this.value;
    this.emitValue();
  },

  methods: {
    //Method that bundles changes and emits the final value,
    //  after a set amount of time after final change.
    popEmitStack() {
      if (this.emitStack.length > 1) {
        this.emitStack.pop();
        setTimeout(() => this.popEmitStack(), 10);
      } else if (this.emitStack.length === 1) {
        this.emitStack.pop();
        this.emitValue();
      }
    },
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },
    endInternalEdit(savebool) {
      this.$emit("InternalNormal", savebool);
    },
  },

  computed: {
    rule() {
      if (this.email && this.noempty) {
        return this.noEmptyEmailRule;
      } else if (this.email) {
        return this.emailRule;
      } else if (this.tlf && this.noempty) {
        return this.noEmptypPhoneRule;
      } else if (this.tlf) {
        return this.phoneRule;
      } else if (this.noempty && this.charlimit) {
        return [
          (v) => !!v || this.$t('servicesystem.rules.required_field'),
          (v) => v.length <= this.charlimit || this.$t('servicesystem.rules.carlimit', { lkey: this.charlimit })
        ]
      } else if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },
  },

  watch: {
    //Set initial value
    value: function () {
      this.editValue = this.value;
    },
    //Ques emit of edited value on change
    editValue: function () {
      this.emitStack.push(1);
      this.emitStack.push(2);
      this.popEmitStack();
    },
  },
};
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
</style>

<style scoped>
.smallerinputtext {
  margin-top: 0px !important;
}

.v-input.smallerinputtext input {
  max-height: 16px !important;
  font-size: 15px !important;
}
</style>